import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CheckboxList from '../../portal/controls/checkboxList';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import rolesChackboxListFilter from '../../../services/oidc/rolesCheckboxListFilter';

@inject('inviteUserStore', 'rolesStore', 'RolesCheckboxListStore') @observer
class InviteUserFormRoles extends Component {
  
    async componentDidMount() {
       
        let rolesToShow = await rolesChackboxListFilter.filterRoles(this.props.rolesStore.roles, this.props.inviteUserStore.values.roleIds, this.props.inviteUserStore.values.id);
        
        this.props.RolesCheckboxListStore.buildAddEditCheckboxRolesList(rolesToShow, this.props.inviteUserStore.values.roleIds);  
    }

    toggleSelection = (id) => {
        
        let list = [];

        this.props.RolesCheckboxListStore.addEditSelectableRolesList.forEach((item) => {
            
            if (item.id === id) {
                
                item.selected = !item.selected;
                
                if (item.selected) {
                    this.props.inviteUserStore.setRoleId(id);
                }
                else {
                    this.props.inviteUserStore.removeRoleId(id);
                }
            }

            list.push(item);
        });

        this.props.RolesCheckboxListStore.setAddEditSelectableRolesList(list);
    }

    formatRoleDescription = (role) => {

        return role.description;
    }

    render(){

        if (this.props.rolesStore.roles  == null
                && this.props.permissionsStore.permissions == null) {

            return null;
        }

        return (
            <div className='add-user-form-wrapper'>
                <div className='general-form-wrapper selectable-list-container'>
                    <ValidationTopErrorMessage errorMessage={this.props.inviteUserStore.addUserErrorMessage} />
                    <div className='roles-checkbox-list' data-cy='roles-checkbox-list'>
                        <CheckboxList 
                            selectableList={this.props.RolesCheckboxListStore.addEditSelectableRolesList}
                            formatAdditionalData={this.formatRoleDescription}
                            toggleSelection={this.toggleSelection}
                            height='35vh'
                            rowHeight={55} />
                    </div>
                </div>
            </div>
        );
    }
}

export default InviteUserFormRoles;